import moment from 'moment'
import math from '@/lib/math'
import config from '@/config'
import { formatCurrency } from '@/lib/textutil'
import api from '@/api'

const GlobalLibraries = {
  install(Vue) {
    function definePropGet(name, obj) {
      Object.defineProperty(Vue.prototype, name, {
        get: () => obj,
      })
    }

    definePropGet('math', math)
    definePropGet('api', api)

    const EMPTY_FUNCTION = () => {}

    definePropGet('nop', EMPTY_FUNCTION)
    definePropGet('NOP', EMPTY_FUNCTION)

    definePropGet('moment_format', (str, fmt) => moment(str).format(fmt))

    definePropGet('$evt', new Vue())
    definePropGet('$config', config)

    definePropGet('globalDownloadUsage', (seq) =>
      api.download.invoiceUsage(seq)
    )
    definePropGet('globalDownloadInvoice', (seq, name) =>
      api.download.invoice(seq, name)
    )
    definePropGet('useSocket', true)

    definePropGet('currency', formatCurrency)
    definePropGet('formatCurrency', formatCurrency)

    definePropGet('$platform', config.platform)

    Vue.mixin({
      created() {
        if (this.windowResized) {
          window.addEventListener('resize', this.windowResized)
          this.windowResized()
        }
      },

      destroyed() {
        if (this.windowResized) {
          window.removeEventListener('resize', this.windowResized)
        }
      },

      methods: {
        hasPermission(perm) {
          if (
            !this.$store ||
            !this.$store.state ||
            !this.$store.state.userInfo ||
            !this.$store.state.userInfo.permissions
          ) {
            return false
          }

          if (Array.isArray(perm)) {
            return perm.map(
              (p) => this.$store.state.userInfo.permissions.indexOf(p) !== -1
            )
          }

          return this.$store.state.userInfo.permissions.indexOf(perm) !== -1
        },
      },
    })
  },
}

export default GlobalLibraries
